import AppComponent from '../../mixins/app-component'

import * as Random from '../../utils/Random'

import AppIcon from '../app-icon'

export default
{
    name: 'app-proceeds-graphic',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon
    },

    props: {
        data: { type: Array, default: [] }
    },

    created() {
        this.positionTop = null

        this.canvas = null
        this.context = null

        this.width = null
        this.height = null
        this.graphicCenter = {
            x: null,
            y: null
        }

        this.circles = []
        this.circlesBaseRadius = null
        this.offsetBetweenCircles = null
        this.items = []

        this.elementsData = null

        // Dragging
        this.mouse = {
            x: null,
            y: null
        }

        this.eventHub.$on('application:onEnterFrame', this.onEnterFrame)
        this.eventHub.$on('window:resize', this.resize)
    },

    mounted() {
        this.positionTop = this.$el.getBoundingClientRect().top

        this.canvas = document.querySelector('.js-proceeds-canvas')
        this.context = this.canvas.getContext('2d')

        this.resize()
        this.createCircles()
        this.createItems()

        this.elementsData = this.$el.querySelectorAll('.js-proceeds-canvas-data')

        this.updateDataPosition()
        this.draw()

        this.$el.addEventListener('mousemove', this.onMousemove)
        this.elementsData.forEach(el => {
            el.addEventListener('mouseenter', this.onMouseenter)
        })
        this.elementsData.forEach(el => {
            el.addEventListener('mouseleave', this.onMouseleave)
        })
    },

    destroyed() {
        this.eventHub.$off('application:onEnterFrame', this.onEnterFrame)
        this.eventHub.$off('window:resize', this.resize)

        this.$el.removeEventListener('mousemove', this.onMousemove)
        this.elementsData.forEach(el => {
            el.removeEventListener('mouseenter', this.onMouseenter)
        })
        this.elementsData.forEach(el => {
            el.removeEventListener('mouseleave', this.onMouseleave)
        })
    },

    methods: {
        /* Mouse event */
        onMousemove(event) {
            this.mouse.x = event.clientX - this.$el.getBoundingClientRect().left
            this.mouse.y = event.clientY - this.$el.getBoundingClientRect().top
        },

        onMouseenter(event) {
            const hoverId = parseInt(event.target.getAttribute('data-index'), 10)
            this.items.forEach((item, index) => {
                if (hoverId === index) {
                    item.isHovered = true
                }
            })
        },

        onMouseleave(event) {
            const hoverId = parseInt(event.target.getAttribute('data-index'), 10)
            this.items.forEach((item, index) => {
                if (hoverId === index) {
                    item.isHovered = false
                }
            })
        },
        /* ***** */

        onEnterFrame() {
            const onScreen = this.positionTop && this.positionTop - this.$root.currScrollTop <= this.$root.height && this.positionTop + this.$el.offsetHeight >= this.$root.currScrollTop
            
            if (this.items.length > 0 && onScreen) {
                this.items.forEach(item => {
                    item.angle.start.radian += item.angle.velocity
                    item.angle.end.radian += item.angle.velocity

                    item.angle.start.x = item.radius * Math.cos(item.angle.start.radian) + this.graphicCenter.x
                    item.angle.start.y = item.radius * Math.sin(item.angle.start.radian) + this.graphicCenter.y

                    item.angle.end.x = item.radius * Math.cos(item.angle.end.radian) + this.graphicCenter.x
                    item.angle.end.y = item.radius * Math.sin(item.angle.end.radian) + this.graphicCenter.y

                    // Update size
                    if (item.isHovered) {
                        item.color = '#1f56fb'
                        item.size += 0.3
                        if (item.size >= 12) {
                            item.size = 12
                        }
                    } else {
                        item.color = 'white'
                        item.size -= 0.3
                        if (item.size <= 6) {
                            item.size = 6
                        }
                    }
                })

                this.draw()
            }
        },

        resize() {
            this.width = document.querySelector('.js-proceeds-canvas-container').clientWidth
            this.height = document.querySelector('.js-proceeds-canvas-container').clientHeight

            this.graphicCenter.x = this.width - (this.width / 12 * 2)
            this.graphicCenter.y = this.height / 2

            this.canvas.width = this.width
            this.canvas.height = this.height

            this.circlesBaseRadius = this.width / 100 * 15
            this.offsetBetweenCircles = this.circlesBaseRadius / 100 * 20

            if (this.width <= 770) {
                this.offsetBetweenCircles = this.circlesBaseRadius / 100 * 25
            }

            this.circles.forEach((circle, index) => {
                circle.position = {
                    x: this.graphicCenter.x,
                    y: this.graphicCenter.y
                }
                circle.radius = this.circlesBaseRadius + (this.offsetBetweenCircles * index)
            })

            this.items.forEach((item, index) => {
                item.position = {
                    x: this.graphicCenter.x,
                    y: this.graphicCenter.y
                }
                item.radius = this.circlesBaseRadius + (this.offsetBetweenCircles * index)

                item.isHovered = false
            })

            this.draw()

            if (this.elementsData) this.updateDataPosition()
        },

        updateDataPosition() {
            let angle = (Math.PI / 2) + (Math.PI / (this.elementsData.length + 1))
            const step = Math.PI / (this.elementsData.length + 1)
            const radius = this.circlesBaseRadius + (this.offsetBetweenCircles * (this.data.length + 1))

            // const lines = this.$el.querySelectorAll('.js-proceeds-canvas-data-line')
            // const linesBaseWidth = 1000 // px

            this.elementsData.forEach((el, index) => {
                const x = radius * Math.cos(angle)
                const y = radius * Math.sin(angle)

                el.style.transform = `translateX(calc(${x}px)) translateY(calc(${y}px)) translateZ(0)`

                angle += step

                // const line = lines[index]
                //
                // const lineX = line.getBoundingClientRect().left - this.$el.getBoundingClientRect().left
                // const lineY = line.getBoundingClientRect().top - this.$el.getBoundingClientRect().top
                //
                // const rotateZ = Math.atan2(parseInt((this.graphicCenter.y) - lineY, 10), parseInt((this.graphicCenter.x) - lineX, 10)) * 180 / Math.PI
                // const scaleX = ((this.data.length - index) * this.offsetBetweenCircles - ((index + 1) * 4)) / linesBaseWidth
                //
                // line.style.transform = `rotateZ(${rotateZ}deg) scaleX(${scaleX}) translateZ(0)`
            })

            this.items.forEach((item, index) => {
                item.line = this.createLine(index)
            })
        },

        createCircles() {
            // Reset items array
            this.items.length = 0
            this.items = []

            this.data.forEach((data, index) => {
                const circle = {
                    position: {
                        x: this.graphicCenter.x,
                        y: this.graphicCenter.y
                    },
                    radius: this.circlesBaseRadius + (this.offsetBetweenCircles * index)
                }

                this.circles.push(circle)
            })

            this.drawCircles()
        },

        createItems() {
            // Reset items array
            this.items.length = 0
            this.items = []

            this.data.forEach((data, index) => {
                const item = {
                    position: {
                        x: this.graphicCenter.x,
                        y: this.graphicCenter.y
                    },
                    radius: this.circlesBaseRadius + (this.offsetBetweenCircles * index),
                    size: 6,
                    angle: {},
                    center: {},
                    color: 'white',
                    percent: data.percent
                }

                item.isHovered = false

                item.angle.random = Random.randomBetween((Math.PI / 2) - (Math.PI / 2 / 100 * 10), (Math.PI / 2) + (Math.PI / 2 / 100 * 10))
                item.angle.velocity = Random.randomBetween(-(2 * Math.PI), (2 * Math.PI)) / (item.radius * 2)

                // Starting point
                item.angle.start = {}
                item.angle.start.radian = 0 + item.angle.random
                item.angle.start.x = item.radius * Math.cos(item.angle.start.radian) + this.graphicCenter.x
                item.angle.start.y = item.radius * Math.sin(item.angle.start.radian) + this.graphicCenter.y

                // Ending point
                item.angle.end = {}
                item.angle.end.radian = ((2 * Math.PI) / 100 * data.percent) + item.angle.random
                item.angle.end.x = item.radius * Math.cos(item.angle.end.radian) + this.graphicCenter.x
                item.angle.end.y = item.radius * Math.sin(item.angle.end.radian) + this.graphicCenter.y

                this.items.push(item)
            })

            this.drawItems()
            this.drawLines()
        },

        createLine(index) {
            const line = {}
            const element = this.$el.querySelectorAll('.js-proceeds-canvas-data')[index]

            line.start = {
                x: element.getBoundingClientRect().left - this.$el.getBoundingClientRect().left + element.offsetWidth - 20,
                y: element.getBoundingClientRect().top - this.$el.getBoundingClientRect().top + (element.offsetHeight / 2) - 2
            }

            line.end = {}
            line.end.x = this.graphicCenter.x + (((this.items[index].radius + this.items[index].size) * (line.start.x - this.graphicCenter.x)) / (Math.sqrt(((line.start.x - this.graphicCenter.x) * (line.start.x - this.graphicCenter.x)) + (line.start.y - this.graphicCenter.y) * (line.start.y - this.graphicCenter.y))))
            line.end.y = this.graphicCenter.y + (((this.items[index].radius + this.items[index].size) * (line.start.y - this.graphicCenter.y)) / (Math.sqrt(((line.start.x - this.graphicCenter.x) * (line.start.x - this.graphicCenter.x)) + (line.start.y - this.graphicCenter.y) * (line.start.y - this.graphicCenter.y))))

            line.radian = Math.atan2(this.graphicCenter.y - line.end.y, this.graphicCenter.x - line.end.x)

            return line
        },

        draw() {
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)

            this.context.beginPath()

            const gradient = this.context.createRadialGradient(this.graphicCenter.x, this.graphicCenter.y, this.graphicCenter.x, this.graphicCenter.x, this.graphicCenter.y, 0)
            gradient.addColorStop(0, 'rgba(31, 86, 251, 0)')
            gradient.addColorStop(1, 'rgba(31, 86, 251, 0.25)')

            // Fill with gradient
            this.context.fillStyle = gradient
            this.context.fillRect(0, 0, this.width, this.height)
            this.context.closePath()

            this.drawCircles()
            this.drawItems()
            this.drawLines()
        },

        drawCircles() {
            this.circles.forEach(circle => {
                this.context.beginPath()
                this.context.arc(circle.position.x, circle.position.y, circle.radius, 0, 2 * Math.PI, false)
                this.context.lineWidth = 2
                this.context.strokeStyle = 'rgba(255, 255, 255, 0.1)'
                this.context.stroke()
                this.context.closePath()
            })
        },

        drawItems() {
            this.items.forEach(item => {
                // Arc
                this.context.beginPath()
                this.context.arc(item.position.x, item.position.y, item.radius, item.angle.start.radian, item.angle.end.radian, false)
                this.context.lineWidth = item.size
                this.context.strokeStyle = item.color
                this.context.stroke()
                this.context.closePath()
            })
        },

        drawLines() {
            this.items.forEach(item => {
                if (item.line) {
                    this.context.beginPath()
                    this.context.moveTo(item.line.start.x, item.line.start.y)
                    this.context.lineTo(item.line.end.x, item.line.end.y)
                    this.context.strokeStyle = 'rgba(31, 86, 251, 0.5)'
                    this.context.lineWidth = 2
                    this.context.stroke()
                    this.context.closePath()
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-proceeds-graphic/script.js